import { ReactNode } from 'react';

export function StrongText({ children }: { children: ReactNode }) {
  return <strong className="font-bold">{children}</strong>;
}
